import { cva, type VariantProps } from "class-variance-authority";

export const dialogSurfaceVariants = cva(
  "fixed left-[50%] top-[50%] z-50 flex w-[calc(100vw-2rem)] max-h-[calc(100dvh-2rem)] translate-x-[-50%] translate-y-[-50%] flex-col rounded-lg border bg-background shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:w-[calc(100vw-3rem)] sm:max-h-[calc(100dvh-3rem)] lg:w-[calc(100vw-4rem)] lg:max-h-[calc(100dvh-4rem)]",
  {
    variants: {
      size: {
        sm: "max-w-[28rem]",
        md: "max-w-[36rem]",
        lg: "max-w-[46rem]",
        xl: "max-w-[58rem] ![--tw-enter-scale:1] ![--tw-exit-scale:1]",
        "2xl": "max-w-[80rem] ![--tw-enter-scale:1] ![--tw-exit-scale:1]",
        full: "h-[calc(100dvh-2rem)] max-w-none ![--tw-enter-scale:1] ![--tw-exit-scale:1] sm:h-[calc(100dvh-3rem)] lg:h-[calc(100dvh-4rem)]",
      },
    },
    defaultVariants: { size: "lg" },
  },
);

export type DialogSize = NonNullable<VariantProps<typeof dialogSurfaceVariants>["size"]>;

export const dialogScrollVariants = cva(
  "flex min-h-0 flex-auto flex-col overflow-y-auto rounded-[inherit] [&>*:not([data-dialog-body]):not(.flex-1):not(.min-h-0)]:shrink-0",
  {
    variants: {
      flush: {
        true: "gap-0 p-0 [--dialog-px:0px]",
        false: "gap-4 p-[var(--dialog-px)] [--dialog-px:1rem] sm:[--dialog-px:1.5rem]",
      },
    },
    defaultVariants: { flush: false },
  },
);
